import React from 'react';
import type { Project } from '../../types';
import type { AvanceeTimelineStep } from '../../utils/vitrineAvanceeTimeline';
import FeaturedProgramCard from './FeaturedProgramCard';

export type ProjectCardProject = Project & {
  priceMin?: number;
  priceMax?: number;
  /** Ville + code postal, ex. « VANNES - 56000 » */
  location?: string;
  /** Adresse postale affichée sous le titre */
  streetAddress?: string;
  /** Ex. « Offre spéciale », « Frais de notaire offerts » */
  promoLabel?: string;
  /** Badge bas de carte, ex. « Neuf » */
  conditionLabel?: string;
  /** Ex. « Terrain à bâtir », « Bureaux » — sinon dérivé de `type` */
  programTypeLabel?: string;
  /** Surcharge du bandeau sombre (sinon dérivé de `avanceeTimeline`). */
  statusLabel?: string;
  /** Frise d’avancée (catalogue publié). */
  avanceeTimeline?: AvanceeTimelineStep[];
  /** @deprecated Utiliser `tags` (bandeaux orange). */
  secondaryBadgeLabel?: string;
  /** Surface carte vitrine (m²), éventuellement dérivée des lots. */
  surfaceMinM2?: number;
  surfaceMaxM2?: number;
  /** Texte affiché (plages « 1 à 4 », etc.). */
  logementsDisplay?: string;
  zoneType?: string | null;
  classification?: string | null;
};

interface ProjectCardProps {
  project: ProjectCardProject;
  onClick?: () => void;
  className?: string;
}

/** Carte programme — style sombre unifié (catalogue, carte, homepage). */
const ProjectCard: React.FC<ProjectCardProps> = ({ project, onClick, className = '' }) => (
  <FeaturedProgramCard project={project} onClick={onClick} className={className} />
);

export default ProjectCard;
